import React, { useState, useEffect } from 'react'; // Import useState and useEffect
import { Link, useNavigate } from 'react-router-dom';
import logo from "../assets/images/logo.png";

const Navbar = () => {
  const navigate = useNavigate();
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');

  // Use useEffect to get the name from localStorage when the component mounts
  // or when localStorage might have been updated (e.g., after login).
  useEffect(() => {
    const storedFirstName = localStorage.getItem('firstname');
    const storedLastName = localStorage.getItem('lastname');

    if (storedFirstName) {
      setFirstName(storedFirstName);
    }
    if (storedLastName) {
      setLastName(storedLastName);
    }
  }, []); // Empty dependency array means this runs once on mount

  const handleLogout = () => {
    localStorage.clear();
    navigate('/login');
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-light shadow-sm" style={{background:"#f06969"}}>
      <div className="container">
        <Link className="navbar-brand" to="/dashboard">
          <img src={logo} width={150} alt="Logo" />
        </Link>

        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav ms-auto">
            {/* Profile Dropdown */}
            <li className="nav-item dropdown">
              <a className="nav-link dropdown-toggle" href="#" id="userDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                {/* Display the user's name from state, or a fallback */}
                👤 {firstName || lastName ? `${firstName} ${lastName}`.trim() : 'User'}
              </a>

              <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="userDropdown">
                <li>
                  <Link className="dropdown-item" to="/profile">My Profile</Link>
                </li>
                <li>
                  <Link className="dropdown-item" to="/changepassword">Change Password</Link>
                </li>
                <li><hr className="dropdown-divider" /></li>
                <li>
                  <button className="dropdown-item" onClick={handleLogout}>Logout</button>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
  
};

export default Navbar;